import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
  HrBorderRadiusInputs,
  HrLightOrange,
  HrPastelGray,
  HrPastelGreen,
  HrPastelOrange,
  HrPastelRed,
  HrPrimary,
  HrRed,
  HrSecondary
} from '@components/styles/hr-styles';

const tagStatusColors = {
  0: HrPastelGray,
  1: HrPastelGreen,
  2: HrPastelRed,
  3: HrPastelOrange,
  10: HrPastelGray,
  13: HrPastelOrange,
  20: HrPastelGray,
  23: HrPastelOrange
};

const Tag = styled.div`
  border: none;
  padding: 4px 8px;
  border-radius: ${HrBorderRadiusInputs};
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  height: 24px;
  white-space: nowrap;

  background-color: ${({ status }) => tagStatusColors[status] ?? HrPastelGray};
`;

const statusColors = {
  0: HrSecondary,
  1: HrPrimary,
  2: HrRed,
  3: HrLightOrange,
  10: HrSecondary,
  13: HrLightOrange,
  20: HrSecondary,
  23: HrLightOrange
};

const Status = styled.div`
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 50%;

  background-color: ${({ status }) => statusColors[status] ?? HrSecondary};
`;

const IconRequestGreen = styled.i`
  background-color: #24bb71;
  color: #fff !important;
  border-radius: 50%;
  padding: 1px;
`;

const IconRequestBlue = styled(IconRequestGreen)`
  background-color: #3598dc;
`;

export const TABLE_COLUMNS = [
  { Header: 'ID', accessor: '_id' },
  { Header: 'ID VACANCY', accessor: 'idVacancy' },
  {
    Header: 'NOMBRE DEL PUESTO',
    accessor: 'name',
    Cell: ({ row }) => {
      const renderIcon = row.original.isDraft ? (
        <IconRequestBlue className='hr-Info' title='Solicitud sin finalizar la creación de vacante.' />
      ) : (
        row.original.isNew && <IconRequestGreen className='hr-Plus' title='Nueva solicitud' />
      );
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          {renderIcon}
          {row.values.name}
        </div>
      );
    }
  },
  {
    Header: 'ESTADO',
    accessor: 'status',
    Cell: ({ value }) => {
      const [t] = useTranslation();
      return (
        <Tag status={value}>
          <Status status={value} />
          <span>{t(`requestVacancies.colaborativeSelection.table_columns.value.${value}`)}</span>
        </Tag>
      );
    }
  },
  { Header: 'AUTORIZÓ', accessor: 'authorizingUser' },
  { Header: 'SOLICITANTE', accessor: 'applicantName' },
  { Header: 'EMAIL', accessor: 'applicantEmail' },
  { Header: 'FECHA DE ENVÍO', accessor: 'created' }
];
